<div class="header-left">
  <!-- Mobile sidebar toggle button -->
  <app-button
    variant="header-mobile-toggle"
    (click)="toggleMobileSidebar.emit()"
    class="mobile-toggle-btn">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  </app-button>

  <app-logo customClass="if-logo-cabinet"></app-logo>
  @if (shouldShowCompanyLogo()) {
    <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.35 1.78406L1.41211 26.14"
        stroke="#F4F4F4"
        stroke-width="2.00264"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
    <img [src]="currentCompany()?.logo_url" [alt]="currentCompany()?.name || ''" class="if-company-logo-cabinet" />
  }
</div>
<div class="header-right">
  @if (pluginConnected()) {
    <span
      class="plugin-badge"
      aria-label="Plugin connection status: connected"
      title="A CAD plugin is currently connected to the Plugin API">
      Plugin Connected
    </span>
  }
  @if (badgeText()) {
    <button
      type="button"
      class="license-badge"
      [class]="badgeClass()"
      [attr.aria-label]="'License status: ' + badgeText()"
      (click)="onBadgeClick()">
      {{ badgeText() }}
    </button>
  }
  <ng-content></ng-content>
</div>
